export default __webpack_public_path__ + "static/media/submit-requirement.91c22c9c.svg";